<template>
  <div v-loading="loading">
    <div>
      <el-table
        :data="list"
        width="100%"
        height="420"
        highlight-current-row
        @current-change="handleCurrentChange">
        <el-table-column
          property="id"
          label="ID"
          width="120">
        </el-table-column>
        <el-table-column
          property="title"
          label="标题名称"
          >
        </el-table-column>
        <el-table-column
          property="links"
          label="链接"
          >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        :page-size="params.pageSize"
        layout="prev, pager, next"
        :total="total"
        @current-change="pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import api from '@/api'

  export default {
    props: {
      type: {
        type: String,
        default: ''
      },
      keywords: {
        type: String,
        default: ''
      },
      store: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        list: [],
        params: {
          pageSize: 10,
          page: 1
        },
        total: 0,
        loading: false
      }
    },
    computed: {
      ...mapGetters([
        'template_name'
      ])
    },
    watch: {
      type(val) {
        if (val) {
          this.params.page = 1
          this.fetch(val)
        }
      },
      keywords(val) {
        this.params.page = 1
        this.fetch(this.type)
      },
      store(val) {
        this.params.page = 1
        this.fetch(this.type)
      }
    },
    methods: {
      fetch (type) {
        this.loading = true
        let query = JSON.parse(JSON.stringify(this.params))
        Object.assign(query, {
          template_name: this.template_name,
          title: this.keywords
        })
        api.wxa.getCustomLinkPageList(query).then(res => {
          let list = []
          res.data.data.list.map(item => {
            list.push({
              id: item.id,
              title: item.title,
              links: item.links
            })
          })
          this.list = list
          this.total = res.data.data.total_count
          this.loading = false
        });
      },
      pageChange (val) {
        this.params.page = val
        this.fetch(this.type)
      },
      handleCurrentChange (val) {
        this.$emit('onClick', val)
      }
    },
    mounted () {
      this.fetch(this.type)
    }
  }
</script>

<style scoped lang="scss">
  .pager {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// link.vue?5d5f4c0d